import React from 'react';
import './permission info.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message } from "antd";

// PAGE_CONFIGS now only stores the State Key and the API Enum.
// The label property is replaced with label to allow dynamic language switching.
const PAGE_CONFIGS = [
    { key: 'showDashboard', enum: 'DASHBOARD', label: 'dashboard' },
    { key: 'showFeatures', enum: 'FEATURES', label: 'Features' },
    { key: 'showSettings', enum: 'SETTINGS', label: 'setting' },
    { key: 'showPermissions', enum: 'PERMISSIONS', label: 'permissions' },
    { key: 'showTransactions', enum: 'TRANSACTIONS', label: 'Transactions' },
    { key: 'showPackages', enum: 'PACKAGES', label: 'Packages' },
    { key: 'showCategories', enum: 'CATEGORIES', label: 'categories' },
    { key: 'showFaq', enum: 'FAQ', label: 'questions' },
    { key: 'showCountries', enum: 'COUNTRIES', label: 'Countries' },
    { key: 'showContactUs', enum: 'CONTACT-US', label: 'contactUs' },
    { key: 'showSubAdmin', enum: 'SUB-ADMIN', label: 'subAdmin' },
    { key: 'showContactRequest', enum: 'CONTACT-REQUEST', label: 'contactRequests' },
    { key: 'showAddUser', enum: 'ADD-USER', label: 'AddUser' },
    { key: 'showNoReplyInterests', enum: 'NO-REPLY-INTERESTS', label: 'noReplyInterests' },
    { key: 'showPaymentPlan', enum: 'PAYMENT-PLANS', label: 'PaymentPlans' },
    { key: 'showAnoncement', enum: 'ANONCEMENTS', label: 'anoncements' },
    { key: 'showNews', enum: 'NEWS', label: 'news' },
    { key: 'showCompany', enum: 'COMPANIES', label: 'companies' },
    { key: 'showProjects', enum: 'PROJECTS', label: 'projects' },
    { key: 'showProjectReport', enum: 'PROJECT-REPORTS', label: 'projectReport' },
    { key: 'showVisiting', enum: 'VISITINGS', label: 'visitings' },
    { key: 'showViews', enum: 'VIEWS', label: 'views' },
    { key: 'showInterests', enum: 'INTERESTS', label: 'interests' },
    { key: 'showOffices', enum: 'OFFICES', label: 'offices' },
    { key: 'showRequest', enum: 'REQUESTS', label: 'requests' },
    { key: 'showAds', enum: 'ADS', label: 'ads' },
    { key: 'showClients', enum: 'CLIENTS', label: 'Clients' },
    { key: 'showAbout', enum: 'ABOUT', label: 'about' },
    { key: 'showNotifs', enum: 'NOTIFS', label: 'notifs' },
    { key: 'showContactUs', enum: 'CONTACT-US', label: 'contactUs' },
    { key: 'showCollection', enum: 'COLLECTION', label: 'financialCollection' },
    { key: 'showDeals', enum: 'DEALS', label: 'Deals' },
    { key: 'showMarketingRequest', enum: 'MARKETING-REQUESTS', label: 'marketingRequests' },
    { key: 'showRefundDeposits', enum: 'REFUND-DEPOSITS', label: 'refundDeposit' },
    { key: 'showDeveloperRequests', enum: 'DEVELOPER-REQUESTS', label: 'developerRequests' },
    { key: 'showSalesTeams', enum: 'SALES-TEAMS', label: 'salesTeams' },
    { key: 'showCompanyInterests', enum: 'COMPANIES-INTERESTS', label: 'companiesInterests' },

];

const initializePageStates = (data) => {
    const pages = data.pages || [];
    const state = {};
    PAGE_CONFIGS.forEach(config => {
        state[config.key] = pages.includes(config.enum);
    });
    return state;
};

class permissionInfo extends React.Component {
    state = {
        actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
        id: this.props.location.state.data.id,
        permission_en: this.props.location.state.data.permission_en,
        permission_ar: this.props.location.state.data.permission_ar,
        pages: this.props.location.state.data.pages,
        type: this.props.location.state.data.type,
        ...initializePageStates(this.props.location.state.data),
    };

    constructor(props) {
        super(props)
        window.scrollTo(0, 0)
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }

    componentDidMount() {
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }

    togglePermission = (key, value) => {
        if (this.state.actionType === "EDIT") {
            this.setState({ [key]: value });
        }
    }

    updatePermission = () => {
        const { permission_en, permission_ar, type } = this.state
        if (hasValue(permission_en) && hasValue(permission_ar)) {
            let l = message.loading('Wait..', 2.5)
            const data = {
                'permission_en': permission_en,
                'permission_ar': permission_ar,
                'type': type,
            }

            let permissions = [];
            PAGE_CONFIGS.forEach(config => {
                if (this.state[config.key] === true) {
                    permissions.push(config.enum);
                }
            });

            data.pages = permissions
            console.log(data)

            axios.put(`${BASE_END_POINT}permission/${this.props.location.state.data.id}`, JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            }).then(response => {
                console.log("PERMISSION UPDATED ", response.data)
                l.then(() => message.success(allStrings.done, 2.5))
                this.props.history.goBack()
            })
                .catch(error => {
                    console.log(error.response)
                    l.then(() => message.error(allStrings.error, 2.5))
                })
        }
    }

    deletePermission = () => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}permission/${this.props.location.state.data.id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            },
        }).then(response => {
            console.log("permission DELETED")
            l.then(() => message.success(allStrings.done, 2.5))
            this.props.history.goBack()
        })
            .catch(error => {
                console.log(error.response)
                l.then(() => message.error(allStrings.error, 2.5))
            })
    }

    submitHandler = event => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.updatePermission()
    };

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    renderPermissionToggle = (key, label) => {
        const isEnabled = this.state[key];
        label = allStrings[label];

        return (
            <MDBCol xl="3" lg="4" md="6" sm="12" key={key}>
                <MDBRow>
                    <MDBCol md="6">
                        <div className="checking" style={{ pointerEvents: this.state.actionType !== "EDIT" ? 'none' : 'auto' }}>
                            <div className="checkingLeft" onClick={() => this.togglePermission(key, false)}
                                style={{ background: isEnabled ? 'transparent' : "mediumseagreen" }}>
                                <span style={{
                                    padding: '5px 25px',
                                    display: 'inline-block',
                                    color: isEnabled ? 'crimson' : '#fff',
                                    fontWeight: '600'
                                }}>{allStrings.no}</span>
                            </div>
                            <div className="checkingRight" onClick={() => this.togglePermission(key, true)}
                                style={{ background: isEnabled ? "mediumseagreen" : 'transparent' }}>
                                <span style={{
                                    color: isEnabled ? '#fff' : 'crimson',
                                    padding: ' 4px 10px',
                                    display: 'inline-block',
                                    fontWeight: '600'
                                }}>{allStrings.yes}</span>
                            </div>
                        </div>
                    </MDBCol>
                    <MDBCol md="6">
                        <label htmlFor={`toggle-${key}`} className="grey-text formLabel">
                            {label}
                        </label>
                    </MDBCol>
                </MDBRow>
            </MDBCol>
        );
    }

    render() {
        if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('PERMISSIONS')) return <Redirect to='/Home' />
        return (
            <div className="App">
                <MDBContainer>
                    <MDBRow>
                        <MDBCol md="12">
                            <div className="infoCard">
                                <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                                    <CardMedia style={{ height: "0px" }} />
                                    <CardHeader></CardHeader>
                                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                                        <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                                            <span className="material-icons" style={{ color: 'white', fontSize: 20 }}>lock</span>
                                        </div>
                                        <div className="tableTitle" style={{
                                            display: 'inline-block', marginTop: '-60px',
                                            marginLeft: '0', marginRight: '0'
                                        }}>
                                            <p>{allStrings.permissionInfo}</p>
                                        </div>
                                    </div>
                                    <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                                        <MDBContainer>
                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <form
                                                        className="needs-validation"
                                                        onSubmit={this.submitHandler}
                                                        noValidate
                                                    >
                                                        <div className="grey-text">
                                                            {this.state.actionType === "VIEW" &&
                                                                <MDBRow>
                                                                    <MDBCol md="12">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr' }} value={this.state.id} type="text" id="form8" className="form-control" required />
                                                                        </div>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }
                                                            <MDBRow>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishName}</label>
                                                                        <input disabled={this.state.actionType === "VIEW"} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$؟'"?#*&()_^&!\\/\s-_]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr' }} value={this.state.permission_en} type="text" id="form645" name="permission_en" className="form-control" onChange={this.changeHandler} required placeholder="أدخل اسم الصلاحية بالانجليزية..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form56" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicName}</label>
                                                                        <input disabled={this.state.actionType === "VIEW"} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^\u0600-\u06FF0-9\u0660-\u0669#.,@?؟%$_^*()/\\ _-]+/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr' }} value={this.state.permission_ar} type="text" id="form56" name="permission_ar" className="form-control" onChange={this.changeHandler} required placeholder="أدخل اسم الصلاحية بالعربية..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>

                                                            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                {/* Pass the state key and the string key to the render function */}
                                                                {PAGE_CONFIGS.map(item => this.renderPermissionToggle(item.key, item.label))}
                                                            </MDBRow>
                                                        </div>
                                                        <br></br>
                                                        <br></br>
                                                        <div className="text-center">
                                                            {this.state.actionType === "EDIT" &&
                                                                <MDBBtn
                                                                    style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}
                                                                    rounded
                                                                    color="#1D9598"
                                                                    type="submit"
                                                                    className="btn-block z-depth-1a"
                                                                >
                                                                    <MDBIcon icon="edit" className="mr-2" />
                                                                    {allStrings.update}
                                                                </MDBBtn>
                                                            }{this.state.actionType === "VIEW" &&
                                                                <MDBBtn onClick={() => { this.deletePermission() }} rounded style={{ background: 'linear-gradient(135deg, #FF3547, #B71C1C)', color: '#fff' }} color="FF3547" className="btn-block z-depth-1a">
                                                                    <MDBIcon icon="trash-alt" className="mr-2" />
                                                                    {allStrings.remove}
                                                                </MDBBtn>
                                                            }

                                                        </div>
                                                    </form>
                                                </MDBCol>
                                            </MDBRow>
                                        </MDBContainer>
                                    </CardContent>
                                </Card>
                            </div>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </div>
        );
    }
}

const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
});
const mapDispatchToProps = {
};

export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(permissionInfo)
);